import { computed } from 'vue';

import { GlobalState } from '@/global';
import { findUnroutedNumbers } from '@/modules/talk/helpers/number-routing';
import { DataCache } from '@/shared/data/cache';
import { hasPermission } from '@/shared/helpers/permissions.helpers';

import { isModernTalkBackend } from './talk-backend';

/**
 * How many live numbers have nowhere to send an inbound call.
 *
 * Not a fault — the tenant can still place calls, and a number bought minutes ago is legitimately
 * unrouted — so it raises the attention dot rather than the red marker the e911 gaps use. The
 * ZynoTalk overview lists them one per number with a fix action, which is where the dot points.
 *
 * Same shape as its siblings: gated on tenant-admin + Talk, reading the shared `talkNumbers` entry
 * lazily so a nav dot never provokes the request on its own. Zynotalk backend only: a FusionPBX
 * tenant's numbers are routed in FusionPBX and carry no target here.
 */
export const talkUnroutedNumberCount = computed<number>(() => {
    if (!GlobalState.tenant.value?.isAdmin || !hasPermission('talk') || isModernTalkBackend.value !== true) return 0;
    const numbers = DataCache.getLazyRef('talkNumbers').value;
    return numbers ? findUnroutedNumbers(numbers).length : 0;
});

/** Returns the shared count, kicking the (gated, deduped) load if it hasn't run yet. */
export function useTalkUnroutedNumbers() {
    if (GlobalState.tenant.value?.isAdmin && hasPermission('talk')) {
        DataCache.getRef('talkTenant');
        DataCache.getRef('talkNumbers');
    }
    return talkUnroutedNumberCount;
}
